module.exports = __webpack_public_path__ + "img/病毒查杀.a8d4aee9.png";